import React from 'react';
import { NotificationProps, NotificationType } from './types';
import { NotificationContainer } from './styled';

export const Notification: React.FC<NotificationProps> = ({
  message,
  type,
  isClosing,
  closeNotification
}) => (
  <NotificationContainer
    type={type}
    $isClosing={isClosing}
    onClick={closeNotification}
    data-cy={`notification-${
      NotificationType.Success === type ? 'success' : 'error'
    }`}
  >
    {message}
  </NotificationContainer>
);
